import getIn from 'lodash/get';
import noop from 'lodash/noop';
import { call, select } from 'redux-saga/effects';

import * as PlaybackConstants from '../../constants';
import * as D from '../../deps';
import * as PlaybackServices from '../../services';
import * as PlaybackUtils from '../../utils';

const spawn = D.taskManagerSpawnFactory(PlaybackConstants.DOMAIN_NAME);

export function* maybeInsertAMPMetric(track, metric, stationId) {
  const shouldRegisterArtistMessage = track && D.Utils.Playlist.isArtistMessage(track);
  const shouldRegisterVoiceTrack = track && D.Utils.VoiceTrack.isStationVoiceTrack(track);

  if (shouldRegisterArtistMessage) {
    yield call(D.putAndWait, D.Actions.Playback.registerArtistMessageMetric(track, metric));
  }

  if (shouldRegisterVoiceTrack) {
    yield call(D.putAndWait, D.Actions.Playback.registerVoiceTrackMetric(stationId, track, metric));
  }
}

export function* callTrackResumed({ data } = {}) {
  const { forceActive } = data;
  yield call(PlaybackServices.playbackResumed, forceActive);
}

export function* callTrackStarted({ data }) {
  const id = yield select(D.getInDomain('playback.utils.getCurrentPlaylist'));
  const currentTrack = yield select(PlaybackUtils.getPlaylistCurrentTrack, id);
  yield spawn(maybeInsertAMPMetric, currentTrack, D.Constants.Amp.AmpMetrics.AUDIO_IMPRESSION, id);
  yield call(PlaybackServices.trackStarted, data);
}

export function* onTrackEnd(action) {
  try {
    const id = yield select(D.getInDomain('playback.utils.getCurrentPlaylist'));
    yield call(
      D.putAndWait,
      D.getInDomain('playback.actions.playTrackFromStation')({
        ...action.data,
        id,
        next: true,
      }),
    );
    getIn(
      window,
      'DesktopBridge.playOrPauseMedia',
      noop,
    )(
      true,
      D.Utils.SourceType.getDesktopBridgeSourceType(D.Constants.SourceTypes.SourceTypes.STATION),
    );
  } catch (errors) {
    if (errors instanceof D.Errors.TaskManagerError) {
      // A sim stream error just means that the user decided not
      // to take the stream, which is fine; everything else we'll bubble up
      if (!errors.getFirstErrorOfType(D.Errors.SimStreamError)) throw errors;
    } else {
      throw errors;
    }
  }
}

export function* updateServerPlaybackPaused({ content = {} } = {}) {
  if (content.callPlaybackPaused) {
    yield call(PlaybackServices.playbackPaused);
  }
}

export function* updateStation(action) {
  const graphQLMigrationEnabled = yield select(D.Utils.TunerVars.graphQLMigrationEnabled);
  if (graphQLMigrationEnabled) {
    const stationId = action.data.stationId;
    const station = yield select(D.getInDomain('playback.utils.getStationByStationId'), stationId);
    const pandoraId = station.get('pandoraId');
    const name = action.data.name || station.get('name');
    const description = action.data.description || '';
    const enableArtistMessages = action.data.enableArtistMessages;
    yield call(PlaybackServices.updateStationGraphQL, {
      stationId: pandoraId,
      name,
      description,
      enableArtistMessages,
    });
  } else {
    yield call(PlaybackServices.updateStation, action.data);
  }
}
